module.exports = "<app-modal [title]=\"title\" size=\"md\">\r\n    <app-tree-list [list]=\"list\" external=\"true\">\r\n    </app-tree-list>\r\n</app-modal>\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/list-modal/list-modal.component.html
// module id = ./src/app/components/list-modal/list-modal.component.html
// module chunks = main